import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit, Optional, Output, Self
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NgControl,
  ValidationErrors,
  Validator,
  Validators
} from "@angular/forms";
import * as _ from "lodash";

require('./bringoz-chips.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-chips',
  templateUrl: './bringoz-chips.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozChipsComponent implements ControlValueAccessor, Validator, OnInit {

  @Input() selectedValues: string[];
  @Input() options: string[];
  @Input() required = false;
  @Input() placeholder: string = 'Enter value';
  @Output() onValueChange = new EventEmitter<string>();

  public selectedKeys: any;

  constructor(@Optional() @Self() @Inject(NgControl) public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ngOnInit() {
    this.initSelectedValuesMap();
  }


  writeValue(value: any): void {
    this.selectedValues = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange = (value: any) => {
  };
  onTouched = () => {
  };

  onSelectionChange(values: any) {
    this.selectedValues = values;
    this.onChange(values);
    this.onTouched();
    this.onValueChange.emit(values);
    this.initSelectedValuesMap();
  }

  getValidator() {
    return Validators.compose([Validators.required]);
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    const validator = this.getValidator?.();
    if (!validator) {
      return null;
    }
    return validator(control);
  }


  private initSelectedValuesMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedValues, (id) => {
      this.selectedKeys[id] = true;
    });
  }

}
